import {
    Component,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Toast, ToasterService } from '@masar/core/services/toaster.service';

@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styles: [
        `
            .toast-progress {
                animation: toast-progress-shrink linear forwards;
            }

            @keyframes toast-progress-shrink {
                from {
                    width: 100%;
                }
                to {
                    width: 0%;
                }
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ToasterComponent implements OnInit, OnDestroy {
    public toasts: Toast[] = [];

    private destroy$ = new Subject<void>();

    public constructor(private toasterService: ToasterService) {}

    public ngOnInit(): void {
        this.toasterService.toasts$
            .pipe(takeUntil(this.destroy$))
            .subscribe(toasts => (this.toasts = toasts));
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public dismiss(toast: Toast): void {
        this.toasterService.dismiss(toast.id);
    }

    public onMouseEnter(toast: Toast): void {
        this.toasterService.pause(toast.id);
    }

    public onMouseLeave(toast: Toast): void {
        this.toasterService.resume(toast.id);
    }

    public trackByToastId(_index: number, toast: Toast): string {
        return toast.id;
    }

    public getIconClass(type: string): string {
        switch (type) {
            case 'success':
                return 'fa-light fa-check';
            case 'info':
                return 'fa-light fa-circle-info';
            case 'warning':
                return 'fa-light fa-triangle-exclamation';
            case 'error':
                return 'fa-light fa-circle-xmark';
            default:
                return 'fa-light fa-circle-info';
        }
    }
}
